import { render } from "./WalletChoserPanel.vue?vue&type=template&id=85667010"
import script from "./WalletChoserPanel.vue?vue&type=script&lang=js"
export * from "./WalletChoserPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__